(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-nav"] && !Shopify.designMode) return;
  try {
    (function () {
  var desktop = window.matchMedia('(min-width: 750px)');
  function placeHeaderActions() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;
    var icons = header.querySelector('.site-header__icons');
    var target = header.querySelector('[data-ww-navigation-actions]');
    if (!icons || !target) return;
    var origin = header.querySelector('[data-ww-icons-origin]');
    if (!origin) {
      origin = document.createElement('span');
      origin.hidden = true;
      origin.setAttribute('data-ww-icons-origin', '');
      icons.parentNode.insertBefore(origin, icons);
    }
    if (desktop.matches) {
      target.appendChild(icons);
    } else {
      origin.parentNode.insertBefore(icons, origin.nextSibling);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeHeaderActions);
  } else {
    placeHeaderActions();
  }
  desktop.addEventListener('change', placeHeaderActions);
  document.addEventListener('shopify:section:load', placeHeaderActions);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ww-search-query-sync"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-ww-category-search]').forEach(function (form) {
  var input = form.querySelector('[data-search-page-predictive-search-input]');
  var query = form.querySelector('[data-ww-search-query]');
  if (!input || !query) return;
  input.addEventListener('input', function () { query.value = input.value; });
  form.addEventListener('reset', function () { query.value = ''; });
});
  } catch(e) { console.error(e); }
})();

})();
